import PortfolioComponent from "./PortfolioComponent";

export default PortfolioComponent;